import { getFontCss, styleConstants } from '@paywithextend/components'
import { cta_buttonPrimaryBackground } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export default css`
  &.UtilityToolbarDropdown {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;

    & .handleContainer {
      display: inline-block;
      position: relative;
    }

    & .image {
      max-width: ${spacing(5)};
      max-height: ${spacing(5)};
      margin-right: ${spacing(1)};
    }

    & .circleIndicator {
      width: ${spacing(2)};
      height: ${spacing(2)};
      border-radius: 50%;
      background-color: ${cta_buttonPrimaryBackground};
      margin-right: ${spacing(1)};
      flex-shrink: 0;
    }

    & .label {
      ${getFontCss(14, 'inherit', styleConstants.fontFamilies.medium)};
    }

    & .icon {
      margin-left: 4px;
      transition: transform ${transition_slow};
      transform: rotate(180deg);
      &.open {
        transform: rotate(0deg);
      }
    }

    & .dropdownContainer {
      position: absolute;
      top: 100%;
      padding: ${variables.units['base-unit-5']}
        ${variables.units['base-unit-0']}px;
      z-index: 4;
      width: 347px;
      display: flex;
      flex-direction: column;
      margin-top: ${variables.units['base-unit-1']}px;

      &.align-right {
        right: ${variables.units['base-unit-0']}px;
      }

      &.align-left {
        left: ${variables.units['base-unit-0']}px;
      }
    }
  }
`
